<div
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  [class.collapsed]="collapsed"
  [class.open]="collapsed && collapsedOpen$ | async"
  class="sidenav"
>
  <div class="sidenav-toolbar">
    <div class="brand">
      <img class="logo" src="../../../assets/images/logo.svg" />
      <img class="title" src="../../../assets/images/brand.svg" />
    </div>

    <button
      mat-icon-button
      class="collapse-toggle"
      (click)="toggleCollapsed()"
      *ngIf="isDesktop$ | async"
    >
      <mat-icon>{{
        collapsed ? 'radio_button_unchecked' : 'radio_button_checked '
      }}</mat-icon>
    </button>
  </div>

  <div class="sidenav-items">
    <ng-container *ngFor="let item of navigationItems">
      <app-sidenav-item
        [level]="0"
        [item]="item"
        [collapsed]="collapsed"
      ></app-sidenav-item>
    </ng-container>
    <ng-container *hasPlanTier="'tracking'; invertCheck: true">
      <app-sidenav-item
        *ngFor="let item of inventoryItems"
        [level]="0"
        [item]="item"
        [collapsed]="collapsed"
      ></app-sidenav-item>
    </ng-container>
  </div>

  <div class="sidenav-support-links">
    <ng-container *ngFor="let item of supportItems">
      <app-sidenav-item
        [level]="0"
        [item]="item"
        [collapsed]="collapsed"
      ></app-sidenav-item>
    </ng-container>

    <ng-container *hasPlanTier="'tracking'; invertCheck: true">
      <ng-container *hasPrivilege="'subscription/read'">
        <ng-container *ngIf="!collapsed || (collapsedOpen$ | async)">
          <app-sidenav-item
            [level]="0"
            [item]="upgradePlanItem"
            [collapsed]="collapsed"
            [compact]="true"
          ></app-sidenav-item>
        </ng-container>
      </ng-container>
    </ng-container>

    <div class="sidenav-footer">
      <app-settings-menu [user]="user">
        <mat-icon class="item-icon" svgIcon="settings"></mat-icon>
        <span class="item-label">Settings</span>
      </app-settings-menu>
      <a (click)="onSignOut()">
        <mat-icon class="item-icon" svgIcon="sign_out"></mat-icon>
        <span class="item-label">Sign Out</span>
      </a>
    </div>
  </div>
</div>
